import { Card, Flex, Icon, Text, useColorModeValue } from "@chakra-ui/react";
import BathIcon from "@icons/BathIcon";
import { NFTEvent, NFTEventInfo } from "@models/event";
import { DEFAULT_LANGUAGE } from "@models/language";

const AID = process.env.NEXT_PUBLIC_STAY22_AID || "moongate";

const _t = (key?: string, language = DEFAULT_LANGUAGE) => key || "";

const milisecondsToSeconds = (miliseconds: number) => {
  return ~~(miliseconds / 1000);
};

const Stay22HotelBooking = ({
  info,
  event,
}: {
  info: NFTEventInfo;
  event: NFTEvent;
}) => {
  if (!AID || (!info.location && !info.locationQuery)) return <></>;
  const now = milisecondsToSeconds(Date.now());
  const _eventStart = milisecondsToSeconds(event.start);
  const eventStart = _eventStart < now ? now : _eventStart;
  const eventEnd = milisecondsToSeconds(event.end);
  const address = info.locationQuery || info.location;
  const viewMode = "all";
  const listViewExpand = false;
  const mapStyle = "street";
  const isNear = true;
  const zoom = 16;
  const supportedCurrencies = event.currency?.toLowerCase() || "usd";
  const eseetz = "auto";
  const src = `https://www.stay22.com/embed/gm?aid=${AID}&address=${address}&eventstart=${eventStart}&eventend=${eventEnd}&viewmode=${viewMode}&listviewexpand=${listViewExpand}&mapstyle=${mapStyle}&isnear=${isNear}&zoom=${zoom}&supportedcurrencies=${supportedCurrencies}&eseetz=${eseetz}`;
  const bg = useColorModeValue("", "gradientDark");

  return (
    <Card
      direction="column"
      overflow="hidden"
      className="items-start"
      borderRadius="xl"
      width={"100%"}
      bg={bg}
      px={8}
      pb={8}
    >
      <Flex
        direction="row"
        justifyContent="start"
        alignItems={"center"}
        gap={3}
        paddingY={4}
      >
        <Icon as={BathIcon} w={8} h={8} color="primary.300" />

        <Text className="text-2xl dark:text-white">
          {_t("Find a place to stay nearby")}
        </Text>
      </Flex>

      <iframe src={src} id="stay22-widget" className="w-full h-[460px]" />
    </Card>
  );
};

export default Stay22HotelBooking;
